import React from "react";
import LoginMain from "./LoginMain";

export default function LoginPage() {
  return (
    <div>
      <LoginMain />
    </div>
  );
}
